import PropTypes from 'prop-types';
import { useState, useCallback } from 'react';
// @mui
import { wNumber } from '../../../../util/format-number.js';
import {useTheme, Box, MenuItem, CardHeader, TextField, Card, InputAdornment, InputLabel, FormControl, Select } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
// components
import Iconify from 'src/components/iconify/index.js';
import Chart, { useChart } from 'src/components/chart/index.js';
import CustomPopover, { usePopover } from 'src/components/custom-popover/index.js';

// ----------------------------------------------------------------------

export default function ReportGraph({ title, subheader, chart, onFilters, searchText, trainer, ...other }) {
  const theme = useTheme();

  const {
    colors = [
      [theme.palette.info.light, theme.palette.info.main],
      [theme.palette.success.light, theme.palette.success.main],
      [theme.palette.warning.light, theme.palette.warning.main],
      [theme.palette.error.light, theme.palette.error.main],
      [theme.palette.grey[50], theme.palette.grey[500]]
    ],
    categories,
    series,
    options,
  } = chart;

  const popover = usePopover();

  const [seriesData, setSeriesData] = useState('2024');

  // const chartOptions = useChart({
  //   colors: colors.map((colr) => colr[1]),
  //   fill: {
  //     type: 'gradient',
  //     gradient: {
  //       colorStops: colors.map((colr) => [
  //         { offset: 0, color: colr[0] },
  //         { offset: 100, color: colr[1] },
  //       ]),
  //     },
  //   },
  //   xaxis: {
  //     categories,
  //   },
  //   tooltip: {
  //     fillSeriesColor: false,
  //     y: {
  //       formatter: (value) => fNumber(value)
  //     }
  //   },
    
  //   ...options,
  //   plotOptions: {
  //     bar: {
  //       distributed: true
  //     }
  //   },
  // });

const chartOptions = useChart({
    colors: colors.map((colr) => colr[1]),
    fill: {
      type: 'gradient',
      gradient: {
        colorStops: colors.map((colr) => [
          { offset: 0, color: colr[0] },
          { offset: 100, color: colr[1] },
        ]),
      },
    },
  chart: {
    type: 'bar',
    stacked: true, // ✅ grouped (not stacked)
    toolbar: { show: false },
  },
  plotOptions: {
    bar: {
      horizontal: false, // ✅ vertical columns
      columnWidth: '35%',
      borderRadius: 4,
      distributed: true, // ✅ important: disable distributed mode
      barGap: '10%',
    },
  },
  xaxis: {
    categories,
  },
  legend: {
    position: 'top',
  },
  dataLabels: {
    enabled: true,
  },
  tooltip: {
    fillSeriesColor: false,
    y: {
      formatter: (value) => wNumber(value),
    },
  },
  ...options,
});

  const handleChangeSeries = useCallback(
    (newValue) => {
      popover.onClose();
      setSeriesData(newValue);
    },
    [popover]
  );
      const handleFilterName = useCallback((event) => {
        onFilters('name', event.target.value)
    }, [onFilters])

      const handleDateFrom = useCallback((event) =>{
        onFilters('dateFrom', event)
    },[onFilters])

    const handleDateTo = useCallback((event) =>{
        onFilters('dateTo', event)
    },[onFilters])

  return (
    <>
      <Card {...other}>
        <CardHeader
          title={title}
          subheader={subheader}
        />
        <Box
          display="flex"
          justifyContent="flex-end"
          gap={1}
          p={2}

        >
          
          {
            trainer ?
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Trainer/Assessor</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Trainer/Assessor"
                  onChange={handleFilterName}
                  value={searchText?.name}

                >
                  {trainer?.results?.map((item) => {
                    return (
                      <MenuItem key={item._id} value={item.fullName} sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                        {item.fullName}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>

              :
              <TextField
                fullWidth
                value={searchText?.name}
                onChange={handleFilterName}
                placeholder="Search..."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
                    </InputAdornment>
                  )
                }}
                sx={{ width: 420 }}
              />

          }


          <DatePicker
            label="Course Start Date From"
            format='dd/MM/yyyy'
            onChange={handleDateFrom}
            value={searchText?.dateFrom}
            slotProps={{
              textField: {
                fullWidth: true
              },
            }}
            sx={{ width: 410 }}
            renderInput={(params) => <TextField {...params} />}
          />

          <DatePicker
            label="Course Start Date To"
            format='dd/MM/yyyy'
            onChange={handleDateTo}
            value={searchText?.dateTo}
            slotProps={{
              textField: {

              }
            }}
            sx={{ width: 410 }}
            renderInput={(params) => <TextField {...params} />}
          />
        </Box>

        {series.map((item) => (
          <Box key={item.year} sx={{ mt: 3, mx: 3 }}>
            {item.year === seriesData && (
              <Chart dir="ltr" type="bar" series={item.data} options={chartOptions} height={364} />
            )}
          </Box>
        ))}
      </Card>

      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 140 }}>
        {series.map((option) => (
          <MenuItem
            key={option.year}
            selected={option.year === seriesData}
            onClick={() => handleChangeSeries(option.year)}
          >
            {option.year}
          </MenuItem>
        ))}
      </CustomPopover>
    </>
  );
}

ReportGraph.propTypes = {
  chart: PropTypes.object,
  subheader: PropTypes.string,
  title: PropTypes.string,
  searchText: PropTypes.any,
  onFilters: PropTypes.func,
   trainer: PropTypes.array
}
